import Debug from 'debug';
import _ from 'lodash';
import moment from 'moment-timezone';
const debug = Debug(`knack.core.helpers.reports.processSQLDateTimeGroupYear`);
export const processSQLDateTimeGroupYear = (group, old_filters, app_now, column, filter, report, current_moment_time) => {
    debug(`report-helper._processSQLDateTimeGroupYear`);
    let limit;
    let offset;
    if (group.limit === `from_to` || group.limit === `from`) {
        const now = _.cloneDeep(current_moment_time);
        const to = (group.limit === `from_to`) ? moment(group.date_to).subtract(1, `days`) : moment(new Date()).add(`years`, 1);
        const from = moment(group.date_from).subtract(1, `days`);
        limit = Math.ceil(to.diff(from, `years`, true)) + 1;
        offset = Math.ceil(now.diff(to, `years`, true));
    }
    else {
        limit = group.number;
        offset = 0;
    }
    if (limit === 0) {
        limit = 1;
    }
    _(limit).times(function (i) {
        if (group.sort === `asc`) {
            i = (limit - 1) - i;
        }
        const current_offset = i + offset;
        const current_date = _.cloneDeep(current_moment_time);
        current_date.subtract(i + offset, `years`);
        const header = current_date.format(`YYYY`);
        const from = (new moment(app_now).utc()).startOf(`year`);
        const to = (new moment(app_now).utc()).startOf(`year`);
        if (i + offset > 0) {
            from.subtract(current_offset, `years`);
        }
        else if (i + offset < 0) {
            from.add(0 - current_offset, `years`);
        }
        from.subtract(1, `second`);
        if (current_offset === 0) {
            to.add(1, `years`);
        }
        else if (current_offset > 1) {
            to.subtract(current_offset - 1, `years`);
        }
        else {
            to.add(0 - current_offset + 1, `years`);
        }
        to.subtract(1, `second`);
        const value = [
            from.toDate(),
            to.toDate()
        ];
        debug(`year group output value:`);
        debug(value);
        const new_filter = _.cloneDeep(filter);
        new_filter.push({
            field: group.field,
            operator: `is date range`,
            value,
            header
        });
        report.filters.unshift(new_filter);
        if (column === 0) {
            report.filter_groups[report.filter_groups.length - 1].unshift({
                header
            });
        }
    });
};
